import graphql from "../../graphql";

export default {
  namespaced: true,
  state: {
    searchResults: [],
  },
  getters: {
    getSearchResults: state => state.searchResults,
  },
  actions: {
    fetchSearchResults: ({ commit, rootState }, { keywords, city = "" }) => {
      if (keywords?.length) {
        graphql
          .query({
            query: productsQuery(rootState.global.currentLocale),
            variables: { keywords, city },
          })
          .then(response => commit("setSearchResults", response.data.productSearch.products));
      } else {
        commit("setSearchResults", []);
      }
    },
  },
  mutations: {
    setSearchResults: (state, data) => {
      state.searchResults = data;
    },
  },
};

const productsQuery = locale => `
  query ProductSearch($keywords: String!, $city: ID!){
    productSearch(keywords: $keywords, cityZone: $city) {
      products {
        name {
          ${locale}
          de
        }
        permalink
        images {
          url(width: 30, height: 30, operation: crop)
        }
      }
    }
  }
`;
